import { PlanningEventGeneratedEntity } from "./generated/PlanningEventGeneratedEntity";

export abstract class PlanningEventEntity extends PlanningEventGeneratedEntity {
    // Comment to preserve new line
}
